/** What a version row of the history knows about who made it and which source version it came from. */
export type VersionOriginInput = { publishedBy?: string | null; sourceVersion?: number | null }

/**
 * The `publishedBy` marker the server's automatic pass (#760) records on a version a linked clone took from its source
 * by itself. The same value as the API's `AUTO_UPDATE_PUBLISHER`.
 */
export const AUTO_UPDATE_PUBLISHER = 'auto-update'

/**
 * The history line for a version a clone took from its source by itself: "Applied automatically from source vN", N
 * being the owner's version it was made from. Null for every other version: one a person made or updated, the first
 * one, and one another writer (a release) published.
 */
export function versionOriginLabel(version: VersionOriginInput): string | null {
    if (version.publishedBy !== AUTO_UPDATE_PUBLISHER) {
        return null
    }
    return version.sourceVersion == null
        ? 'Applied automatically from source'
        : `Applied automatically from source v${version.sourceVersion}`
}
